import { signupFormWithAnalyticsSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import * as z from "zod";

export const merchantSignupFormWithAnalyticsOutputSchema = z.intersection(
  signupFormWithAnalyticsSchema,
  z.object({ publishedAt: z.date().nullable() }),
);
